// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

/* @media (max-width: 768px) {
  .header {
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    color: #13294b;
    justify-content: center;
    z-index: 1;
    background-color: #f5f5f5 ;
    height: 5rem;
    border-bottom: 1px solid white;
  }

  .nav {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #f5f5f5;
    color: 13294b;
    justify-content: center;
    padding: 10px;
    border-top: 1px solid white;
    height: 5rem;
    z-index: 1;
  }

  .header-title {
    display: flex;
    text-align: left;
    justify-content: left;
    width: 20rem;
    font-family: "Space Mono", monospace;
    font-display: swap;
    padding-left: 1rem;
    padding-top: 1rem;
    font-size: 2rem;
  }

  .navbar {
    display: flex;
    text-align: center;
    justify-content: center;
    width: 20rem;
    font-family: "Space Mono", monospace;
    font-display: swap;
    padding-top: 0.3rem;
    font-size: 1.25rem;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }

  .centered-content {
    display: flex;
    justify-content: center;
    align-items: top;
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
    overflow-y: scroll;
  }

  .nicky-card {
    width: 20rem;
    padding-bottom: 0.5rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;

  }

  .form-label {
    padding-top: 1.5rem;
  }

  .switch-label {
    padding-bottom: 0.5rem;
  }

  .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token {
    margin-bottom: 0.25rem;
  }

  .p-card .p-card-title {
    font-family: "Space Mono", monospace;
    font-display: swap;
  }

  .p-inputtext {
    width: 100%;
  }

  .input-text-area {
    margin-top: 1.2rem;
  }

  .prompt-text-area {
    margin-bottom: 0.5rem;
  }

  .p-component:disabled {
    background-color: #fff;
    color: #13294b;
  }

  .card-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .switch-table {
    border-spacing: 1rem;
  }
}

@media (min-width: 769px) {
  .header {
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    color: #ffffff;
    background-color: #13294b;
    align-items: center;
    z-index: 1;
    height: 4rem;
  }

  .nav {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #f5f5f5;
    color: 13294b;
    justify-content: center;
    padding: 10px;
    border-top: 1px solid white;
    height: 5rem;
    z-index: 1;
  }

  .header-title {
    display: flex;
    text-align: left;
    justify-content: left;
    font-family: "Space Mono", monospace;
    font-display: swap;
    font-size: 2.2rem;
    margin-right: 2rem;
    margin-left: 2rem;
  }

  /* .navbar {
    display: flex;
    text-align: center;
    justify-content: center;
    width: 35rem;
    font-family: "Space Mono", monospace;
    font-display: swap;
    padding-top: 0.3rem;
    font-size: 1.25rem;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }

  .centered-content {
    display: flex;
    justify-content: center;
    align-items: top;
    margin-top: 1rem;
    margin-bottom: 5.5rem;
    overflow-y: scroll;
  }

  .nicky-card {
    width: 20rem;
    padding-bottom: 0.5rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;

  }

  .form-label {
    padding-top: 1.5rem;
  }

  .switch-label {
    padding-bottom: 0.5rem;
  }

  .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token {
    margin-bottom: 0.25rem;
  }

  .p-card .p-card-title {
    font-family: "Space Mono", monospace;
    font-display: swap;
  }

  .p-inputtext {
    width: 100%;
  }

  .input-text-area {
    margin-top: 1.2rem;
  }

  .prompt-text-area {
    margin-bottom: 0.5rem;
  }

  .p-component:disabled {
    background-color: #fff;
    color: #13294b;
  }

  .card-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .web-table {
    width: 90%;
  }

  .switch-table {
    border-spacing: 1rem;
  }

  .dashboard {
    display: flex;
    height: 100vh;
  }

  .left {
    flex: 0 0 15%;
    background-color: rgb(242,242,242);
    padding: 0.5rem 1rem 0.5rem 1rem;
    padding-top: 5rem;
  }

  .center {
    flex: 1;
    padding: 0.5rem 1rem 0.5rem 1rem;
    background-color: rgb(228,228,228);
    padding-top: 5rem;
  }

  .right {
    flex: 0 0 25%;
    background-color: rgb(238,238,238);
    padding: 0.5rem 1rem 0.5rem 1rem;
    padding-top: 5rem;
  }

  .navbar-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
  }

  .custom-dropdown .p-inputtext{
    color: #fff;
  }
} */

.header {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  color: #ffffff;
  background-color: #13294b;
  align-items: center;
  z-index: 1;
  height: 4rem;
}

.header-title {
  font-family: "Sora", sans-serif;
  font-size: 1.9rem;
  font-weight: 600;
  line-height: 1;
}

.app-menubar .p-menubar-start {
  display: flex;
  align-items: center;
  margin-right: 1rem;
}

@media (min-width: 768px) {
  .app-menubar {
    padding-left: 3.25rem;
  }
}

.no-border {
  border: none;
}

.mobile-menu {
  background: #f9fafb;
  color: #4b5563;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  position: fixed;
  bottom: 0;
}

.centered-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10rem;
  margin-bottom: 5.5rem;
  overflow-y: scroll;
}

.p-multiselect-label {
  white-space: normal;
}

.p-multiselect-token {
  margin-bottom: 0.25rem;
}

.p-datatable {
  font-size: 0.92rem;
}

.p-datatable .p-datatable-header {
  padding: 0.9rem 1rem;
}

.p-datatable .p-datatable-thead > tr > th {
  padding: 0.3rem 0.9rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.p-datatable .p-datatable-tbody > tr > td {
  padding: 0.3rem 0.9rem;
  line-height: 1.35;
}

.p-datatable .p-column-header-content,
.p-datatable .p-column-title {
  gap: 0.35rem;
}

.p-datatable .p-paginator {
  padding: 0.6rem 0.9rem;
}

.p-datatable .p-paginator .p-paginator-pages .p-paginator-page,
.p-datatable .p-paginator .p-paginator-first,
.p-datatable .p-paginator .p-paginator-prev,
.p-datatable .p-paginator .p-paginator-next,
.p-datatable .p-paginator .p-paginator-last {
  min-width: 2rem;
  height: 2rem;
}

.p-datatable .p-inputtext,
.p-datatable .p-dropdown,
.p-datatable .p-multiselect {
  font-size: 0.9rem;
}

.layout-sidebar {
  position: fixed;
  width: 300px;
  height: calc(100vh - 6rem);
  z-index: 999;
  overflow-y: auto;
  top: 5rem;
  left: 1rem;
  transition: transform 0.2s, left 0.2s;
  background-color: var(--surface-overlay);
  border-radius: 12px;
  padding: 0.5rem 1.5rem;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.02), 0 0 2px rgba(0, 0, 0, 0.05),
    0 1px 4px rgba(0, 0, 0, 0.08);
}

.layout-right-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  padding: 5rem 2rem 2rem 4rem;
  transition: margin-left 0.2s;
  margin-left: 300px;
}

.layout-main-container {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 6rem);
  justify-content: flex-start;
  padding: 4rem 1rem 2rem 1rem;
  transition: margin-left 0.2s;
}

.p-divider-content {
  background-color: transparent;
}

.chatbot-message-card {
  width: calc(100% - 1rem);
}

@media (min-width: 768px) {
  .chatbot-inner-card {
    max-width: 48rem;
  }
  .chatbot-input-card {
    width: calc(100% - 0.5rem);
  }
  .chatbot-message-card {
    max-width: 48rem;
    width: 48rem;
  }
}

@media (min-width: 1280px) {
  .xl\\:max-w-3xl {
    max-width: 48rem;
  }
}

@media (min-width: 1024px) {
  .lg\\:max-w-2xl {
    max-width: 42rem;
  }
}

.chatbot-main-layout {
  margin-top: 70px;
  overflow-y: scroll;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2RG;;AAEH;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;EAKE,eAAe;EACf,YAAY;AACd;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;EACtB;iCAC+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Sora:wght@600&display=swap\");\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n}\n\n/* @media (max-width: 768px) {\n  .header {\n    position: fixed;\n    display: flex;\n    top: 0;\n    left: 0;\n    width: 100%;\n    color: #13294b;\n    justify-content: center;\n    z-index: 1;\n    background-color: #f5f5f5 ;\n    height: 5rem;\n    border-bottom: 1px solid white;\n  }\n\n  .nav {\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background-color: #f5f5f5;\n    color: 13294b;\n    justify-content: center;\n    padding: 10px;\n    border-top: 1px solid white;\n    height: 5rem;\n    z-index: 1;\n  }\n\n  .header-title {\n    display: flex;\n    text-align: left;\n    justify-content: left;\n    width: 20rem;\n    font-family: \"Space Mono\", monospace;\n    font-display: swap;\n    padding-left: 1rem;\n    padding-top: 1rem;\n    font-size: 2rem;\n  }\n\n  .navbar {\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    width: 20rem;\n    font-family: \"Space Mono\", monospace;\n    font-display: swap;\n    padding-top: 0.3rem;\n    font-size: 1.25rem;\n  }\n\n  code {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n      monospace;\n  }\n\n  .centered-content {\n    display: flex;\n    justify-content: center;\n    align-items: top;\n    margin-top: 5.5rem;\n    margin-bottom: 5.5rem;\n    overflow-y: scroll;\n  }\n\n  .nicky-card {\n    width: 20rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .form-group {\n    display: flex;\n    flex-direction: column;\n\n  }\n\n  .form-label {\n    padding-top: 1.5rem;\n  }\n\n  .switch-label {\n    padding-bottom: 0.5rem;\n  }\n\n  .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token {\n    margin-bottom: 0.25rem;\n  }\n\n  .p-card .p-card-title {\n    font-family: \"Space Mono\", monospace;\n    font-display: swap;\n  }\n\n  .p-inputtext {\n    width: 100%;\n  }\n\n  .input-text-area {\n    margin-top: 1.2rem;\n  }\n\n  .prompt-text-area {\n    margin-bottom: 0.5rem;\n  }\n\n  .p-component:disabled {\n    background-color: #fff;\n    color: #13294b;\n  }\n\n  .card-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .switch-table {\n    border-spacing: 1rem;\n  }\n}\n\n@media (min-width: 769px) {\n  .header {\n    position: fixed;\n    display: flex;\n    top: 0;\n    left: 0;\n    width: 100%;\n    color: #ffffff;\n    background-color: #13294b;\n    align-items: center;\n    z-index: 1;\n    height: 4rem;\n  }\n\n  .nav {\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background-color: #f5f5f5;\n    color: 13294b;\n    justify-content: center;\n    padding: 10px;\n    border-top: 1px solid white;\n    height: 5rem;\n    z-index: 1;\n  }\n\n  .header-title {\n    display: flex;\n    text-align: left;\n    justify-content: left;\n    font-family: \"Space Mono\", monospace;\n    font-display: swap;\n    font-size: 2.2rem;\n    margin-right: 2rem;\n    margin-left: 2rem;\n  }\n\n  /* .navbar {\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    width: 35rem;\n    font-family: \"Space Mono\", monospace;\n    font-display: swap;\n    padding-top: 0.3rem;\n    font-size: 1.25rem;\n  }\n\n  code {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n      monospace;\n  }\n\n  .centered-content {\n    display: flex;\n    justify-content: center;\n    align-items: top;\n    margin-top: 1rem;\n    margin-bottom: 5.5rem;\n    overflow-y: scroll;\n  }\n\n  .nicky-card {\n    width: 20rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .form-group {\n    display: flex;\n    flex-direction: column;\n\n  }\n\n  .form-label {\n    padding-top: 1.5rem;\n  }\n\n  .switch-label {\n    padding-bottom: 0.5rem;\n  }\n\n  .p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token {\n    margin-bottom: 0.25rem;\n  }\n\n  .p-card .p-card-title {\n    font-family: \"Space Mono\", monospace;\n    font-display: swap;\n  }\n\n  .p-inputtext {\n    width: 100%;\n  }\n\n  .input-text-area {\n    margin-top: 1.2rem;\n  }\n\n  .prompt-text-area {\n    margin-bottom: 0.5rem;\n  }\n\n  .p-component:disabled {\n    background-color: #fff;\n    color: #13294b;\n  }\n\n  .card-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .web-table {\n    width: 90%;\n  }\n\n  .switch-table {\n    border-spacing: 1rem;\n  }\n\n  .dashboard {\n    display: flex;\n    height: 100vh;\n  }\n\n  .left {\n    flex: 0 0 15%;\n    background-color: rgb(242,242,242);\n    padding: 0.5rem 1rem 0.5rem 1rem;\n    padding-top: 5rem;\n  }\n\n  .center {\n    flex: 1;\n    padding: 0.5rem 1rem 0.5rem 1rem;\n    background-color: rgb(228,228,228);\n    padding-top: 5rem;\n  }\n\n  .right {\n    flex: 0 0 25%;\n    background-color: rgb(238,238,238);\n    padding: 0.5rem 1rem 0.5rem 1rem;\n    padding-top: 5rem;\n  }\n\n  .navbar-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px;\n  }\n\n  .custom-dropdown .p-inputtext{\n    color: #fff;\n  }\n} */\n\n.header {\n  position: fixed;\n  display: flex;\n  top: 0;\n  left: 0;\n  width: 100%;\n  color: #ffffff;\n  background-color: #13294b;\n  align-items: center;\n  z-index: 1;\n  height: 4rem;\n}\n\n.header-title {\n  font-family: \"Sora\", sans-serif;\n  font-size: 1.9rem;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.app-menubar .p-menubar-start {\n  display: flex;\n  align-items: center;\n  margin-right: 1rem;\n}\n\n@media (min-width: 768px) {\n  .app-menubar {\n    padding-left: 3.25rem;\n  }\n}\n\n.no-border {\n  border: none;\n}\n\n.mobile-menu {\n  background: #f9fafb;\n  color: #4b5563;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  position: fixed;\n  bottom: 0;\n}\n\n.centered-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10rem;\n  margin-bottom: 5.5rem;\n  overflow-y: scroll;\n}\n\n.p-multiselect-label {\n  white-space: normal;\n}\n\n.p-multiselect-token {\n  margin-bottom: 0.25rem;\n}\n\n.p-datatable {\n  font-size: 0.92rem;\n}\n\n.p-datatable .p-datatable-header {\n  padding: 0.9rem 1rem;\n}\n\n.p-datatable .p-datatable-thead > tr > th {\n  padding: 0.3rem 0.9rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.p-datatable .p-datatable-tbody > tr > td {\n  padding: 0.3rem 0.9rem;\n  line-height: 1.35;\n}\n\n.p-datatable .p-column-header-content,\n.p-datatable .p-column-title {\n  gap: 0.35rem;\n}\n\n.p-datatable .p-paginator {\n  padding: 0.6rem 0.9rem;\n}\n\n.p-datatable .p-paginator .p-paginator-pages .p-paginator-page,\n.p-datatable .p-paginator .p-paginator-first,\n.p-datatable .p-paginator .p-paginator-prev,\n.p-datatable .p-paginator .p-paginator-next,\n.p-datatable .p-paginator .p-paginator-last {\n  min-width: 2rem;\n  height: 2rem;\n}\n\n.p-datatable .p-inputtext,\n.p-datatable .p-dropdown,\n.p-datatable .p-multiselect {\n  font-size: 0.9rem;\n}\n\n.layout-sidebar {\n  position: fixed;\n  width: 300px;\n  height: calc(100vh - 6rem);\n  z-index: 999;\n  overflow-y: auto;\n  top: 5rem;\n  left: 1rem;\n  transition: transform 0.2s, left 0.2s;\n  background-color: var(--surface-overlay);\n  border-radius: 12px;\n  padding: 0.5rem 1.5rem;\n  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.02), 0 0 2px rgba(0, 0, 0, 0.05),\n    0 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.layout-right-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  justify-content: space-between;\n  padding: 5rem 2rem 2rem 4rem;\n  transition: margin-left 0.2s;\n  margin-left: 300px;\n}\n\n.layout-main-container {\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 6rem);\n  justify-content: flex-start;\n  padding: 4rem 1rem 2rem 1rem;\n  transition: margin-left 0.2s;\n}\n\n.p-divider-content {\n  background-color: transparent;\n}\n\n.chatbot-message-card {\n  width: calc(100% - 1rem);\n}\n\n@media (min-width: 768px) {\n  .chatbot-inner-card {\n    max-width: 48rem;\n  }\n  .chatbot-input-card {\n    width: calc(100% - 0.5rem);\n  }\n  .chatbot-message-card {\n    max-width: 48rem;\n    width: 48rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .xl\\:max-w-3xl {\n    max-width: 48rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:max-w-2xl {\n    max-width: 42rem;\n  }\n}\n\n.chatbot-main-layout {\n  margin-top: 70px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
